<template>
  <div class="pt-3">
    <v-card class="pa-4 d-flex flex-column rounded-lg" flat>
      <div class="d-flex align-start">
        <v-icon class="mr-2">mdi-clipboard-list-outline</v-icon>
        <div style="width: 100%">
          <b class="medium_txt">Semester GPA </b>
          <div
            v-if="!loading && dataIP"
            class="pa-2 d-flex justify-center flex-column"
          >
            <v-row>
              <v-col cols="12" md="3" v-for="(value, key) in dataIP" :key="key">
                <p class="default_txt">
                  {{ key.replace("semester", "Semester ") }}
                </p>
                <div class="disable_txt">
                  <p class="black--text ma-0">
                    {{ value ? value : "0.00" }}
                  </p>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-row no-gutters class="mt-3" v-if="loading">
            <v-col v-for="n in 8" :key="n" cols="12" md="3">
              <div class="pa-2">
                <v-skeleton-loader width="50%" type="text"></v-skeleton-loader>
                <v-skeleton-loader width="90%" type="text"></v-skeleton-loader>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>

    <div>
      <v-row no-gutters align="center" class="mb-2 mt-4">
        <v-col cols="12" md="8">
          <h3>Submission GPA</h3>
        </v-col>
        <v-col cols="12" md="4" class="d-flex justify-end">
          <v-btn
            color="#016443"
            class="text-capitalize"
            dark
            depressed
            @click="createSubmission"
          >
            + Create
          </v-btn>
        </v-col>
      </v-row>
      <div class="my-2" v-if="!loading && dataSet">
        <v-data-table
          :headers="headers"
          :items="dataSet"
          :page.sync="page"
          :items-per-page="limit"
          class="elevation-0 color_txt"
          hide-default-footer
          :single-select="false"
        >
          <template v-slot:[`item.updated_at`]="{ item }">
            <b>{{ $date(item.updated_at).format("MMM DD, YYYY") }}</b>
          </template>
          <template v-slot:[`item.approval`]="{ item }">
            <div class="d-flex pa-1">
              <v-card
                flat
                class="pa-1 px-3"
                :color="
                  item.approval == 'approved'
                    ? '#006341'
                    : item.approval == 'declined'
                    ? '#FE0404'
                    : item.approval == 'revision'
                    ? '#001A72'
                    : '#B3A369'
                "
              >
                <h4
                  style="
                    color: white;
                    text-transform: uppercase;
                    text-align: center;
                  "
                >
                  {{ item.approval }}
                </h4>
              </v-card>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-btn
                class="mr-2"
                icon
                @click="
                  item.approval == 'revision' ? updateSubmission(item) : null
                "
              >
                <v-icon
                  :color="item.approval == 'revision' ? '#000000' : '#EDF1F0'"
                  >mdi-pencil</v-icon
                >
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <div class="text-center my-2 pa-3" v-if="dataSet">
          <v-pagination
            v-model="page"
            color="#006341"
            @input="fetchData"
            :length="last_page"
          ></v-pagination>
        </div>
      </div>
      <div class="my-2" v-if="loading">
        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
      </div>
      <dialog-large
        :d_large="d_large"
        @refetch="fetchDataScore"
        @close="d_large = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { mapState } from "vuex";
// import DialogLarge from "../../../dialog/dialogLarge.vue";
// import moment from "moment";
export default {
  name: "ipScholar",
  components: {
    apexchart: VueApexCharts,
    // DialogLarge,
    // moment,
  },
  computed: {
    ...mapState({
      id: (state) => state.id,
      profile: (state) => state.profile,
    }),
  },
  data() {
    return {
      d_large: false,
      inventory: "",
      d_type: "",
      d_title: "",
      dataSet: [],
      page: 1,
      limit: 10,
      series: [44, 55],
      find: "",
      total: null,
      last_page: null,
      dataIP: null,
      loading: true,
      headers: [
        {
          text: "Date submitted",
          align: "start",
          value: "updated_at",
        },
        {
          text: "Status",
          align: "start",
          value: "approval",
        },
        {
          text: "Review",
          align: "start",
          value: "notes",
          sortable: false,
        },
        {
          text: "Action",
          align: "start",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    let checker = setInterval(() => {
      if (this.profile) {
        this.fetchDataScore();
        clearInterval(checker);
      }
    }, 300);
  },
  methods: {
    fetchDataScore() {
      this.loading = true;
      let data = {
        path: `scholar/score?scholar_id=${this.profile.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          let obj = {};
          if (data) {
            for (let key in data) {
              if (key.includes("semester")) {
                obj[key] = data[key] ? data[key] : "0.00";
              }
            }
          } else {
            for (let i = 0; i < 8; i++) {
              obj[`semester${i + 1}`] = "0.00";
            }
          }
          this.dataIP = obj;
          this.fetchData();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar/draft?page[number]=${this.page}&page[size]=${this.limit}&sort=-created_at&filter[search]=${this.find}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    createSubmission() {
      let obj = {};
      for (let i = 0; i < 8; i++) {
        obj[`semester${i + 1}`] = "0.00";
      }
      this.inventory = obj;
      this.d_type = "c_submission";
      this.d_title = "New Submission";
      this.d_large = true;
    },
    updateSubmission(item) {
      this.d_type = "u_submission";
      this.d_title = "Update Submission";
      this.d_large = true;
      let obj = {};
      for (let key in item) {
        if (key.includes("semester")) {
          obj[key] = item[key] ? item[key] : "0.00";
        }
      }
      this.inventory = item;
      this.inventory["ip"] = obj;
    },
    row_classes(item) {
      let idx = this.dataSet.indexOf(item);
      if (idx % 2 == 0) {
        return "strip_"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
  },
};
</script>
<style scoped>
.v-pagination__item {
  box-shadow: none !important;
}
.v-pagination__navigation {
  box-shadow: none !important;
}
.disable_txt {
  padding: 10px;
  border-radius: 5px;
  background: #f6f6f6;
}
</style>
